export default __webpack_public_path__ + "static/media/news2.bc78ec8f.jpg";